export default "__VITE_ASSET__CgV3JESD__"